import { Component, ViewChild, AfterViewInit, ViewChildren, QueryList } from '@angular/core';
import { NavController } from 'ionic-angular';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, TooltipPosition } from '@angular/material';
import { SwiftimmoTemplateProvider } from '../../providers/swiftimmo-template/swiftimmo-template'
import { NgxJsonViewerComponent } from '../../components/ngx-json-viewer/ngx-json-viewer';
import { NgxJsonViewerProvider } from "../../providers/ngx-json-viewer/ngx-json-viewer";
import { MappingDialogComponent } from '../../components/mapping-dialog/mapping-dialog';

//import * as $ from 'jquery'

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  providers: [NgxJsonViewerProvider]
})
export class HomePage implements AfterViewInit {

  splash = true;
  text: string;
  afuConfigs = {};
  samplesContent = {};
  mappingsMapping = {};
  mappingsSample = {};
  selectedTemplate: any;
  jsonviewers: NgxJsonViewerComponent[];
  
  constructor(public navCtrl: NavController,
              public template: SwiftimmoTemplateProvider,
              public dialog: MatDialog,
              private jsonViewerProvider: NgxJsonViewerProvider) {
      jsonViewerProvider.segmentSelected$.subscribe(
              segment => {
                  this.jsonViewersSegmentSelected(segment);
          });
      jsonViewerProvider.segmentExpanded$.subscribe(
              segment => {
                  this.jsonViewersSegmentExpanded(segment);
          });
      jsonViewerProvider.segmentCollaped$.subscribe(
              segment => {
                  this.jsonViewersSegmentCollapsed(segment);
          });
  }

  ngAfterViewInit() {
      // subscribe to json view event
      console.log('After View Init');
  }
  
  ionViewDidLoad() {
      setTimeout(() => this.splash = false, 2000);
      setTimeout(() => {
          console.log('load templates');
          this.loadTemplates();
      },200);
      setTimeout(() => {
          console.log('load samples');
          this.loadSamples();
      },200);
      setTimeout(() => {
          console.log('load mapping');
          this.loadMappings();
      },200);
      this.template.messageEvent.subscribe(event => {
          console.log('home receive document ' + event.documentid + ' event');
          // Open new window with pdf
          window.open('api/v1/certinergie/fr/document/' + event.documentid + '/pdf');
      });
    }
  
  jsonViewersSegmentSelected(segment)
  {
      console.log('segment selected');
      console.log(segment);
      let dialogRef = this.dialog.open(MappingDialogComponent, {
          data: {"segment":segment}
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('The dialog was closed');
        });        
  }
  
  jsonViewersSegmentExpanded(segment)
  {
      console.log('segment expanded');
  }
  
  jsonViewersSegmentCollapsed(segment)
  {
      console.log('segment collapsed');
  }
  
  loadSamples()
  {
      this.template.getSamples().subscribe(samples => {
          for (let sample of samples)
          {
              this.samplesContent[sample.id] = JSON.stringify(sample.content);
          }              
      });      
  }
  
  loadMappings()
  {
      this.template.getMappings().subscribe(mappings => {
          for (let mapping of mappings)
          {
              this.mappingsMapping[mapping.id] = JSON.stringify(mapping.mapping);
          }              
      });      
  }
  
  loadTemplates()
  {
      this.template.getTemplates().subscribe(templates => {
          for (let template of templates)
          {
              this.afuConfigs[template.id] = {
                  formatsAllowed:'.odt',
                  uploadAPI: {
                    url:"api/v1/certinergie/fr/template/" + template.id + "/file"
                  }
              }
          }
      });      
  }
  
  clickButton(event)
  {
      console.log(event);
  }
  
  makeDoc(sampleid)
  {
      console.log('MakeDoc ' + sampleid);
      this.template.makeDocument(this.selectedTemplate.id,'pdf',this.template.getSample(sampleid).content).subscribe(documentid => {
         console.log('makeDoc ' + documentid);
      });
  }
  
  selectTemplate(template)
  {
      this.selectedTemplate = template;
  }
  
  addTemplate()
  {
      this.template.addTemplate().subscribe(result => {
          // Update template
          this.loadTemplates();
       });      
  }
  
  updateTemplate(template)
  {
      this.template.updateTemplate(template).subscribe(result => {
      });
  }

  addSample()
  {
      this.template.addSample().subscribe(result => {
         // Update samples
         this.loadSamples();
      });
  }
  
  updateSample(sample)
  {
      sample.content = JSON.parse(this.samplesContent[sample.id]);
      this.template.updateSample(sample).subscribe(result => {
          
      });
  }
  
  addMapping()
  {
      this.template.addMapping().subscribe(result => {
         // Update mappings
         this.loadMappings();
      });
  }
  
  updateMapping(mapping)
  {
//      mapping.content = JSON.parse(this.samplesContent[mapping.id]);
      this.template.updateMapping(mapping).subscribe(result => {
          
      });
  }
  
  selectMappingSample(mapping,sample)
  {
      this.mappingsSample[mapping.id] = sample.content;
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts